import { type StoreApi, type UseBoundStore } from 'zustand';

export const LoadingWrapper = <
  T extends Record<string, any>,
  K extends UseBoundStore<StoreApi<any>>,
>(
  apiObject: T,
  model: K
) => {
  const keys = Object.keys(apiObject) as (keyof T)[];
  const newObject: T = {} as T;
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (typeof apiObject[key] === 'function') {
      // check if the function is async
      // console.log('foifoifji', apiObject[key], apiObject[key].constructor)
      const isAsync = apiObject[key].constructor.name === 'AsyncFunction';
      if (isAsync) {
        newObject[key] = (async (...args: unknown[]) => {
          try {
            // console.log(`Calling ${key} with args:`, args);
            model?.setState({ loading: { [key]: true } });
            // @ts-ignore
            const result = await apiObject[key](...args);
            return result;
          } catch (error) {
            console.error(`Error in ${String(key)}:`, error);
            throw error;
          } finally {
            // console.log(`Finished calling ${key}`);
            model?.setState({ loading: { [key]: false } });
          }
        }) as T[keyof T];
      } else {
        // @ts-ignore
        newObject[key] = apiObject[key];
      }
    }
  }
  return newObject;
};
